import * as types from "../actions/types.js";
 //Utility functions
/******************* 
@purpose : Intital user reducer data
@Author : INIC
******************/
const initialState = {
  token: "",
  userInfo: "",
  trips: {},
  isLogout: true,
};
/******************* 
@purpose : ui reducer
@Parameter : {user_ini_data, action}
@Author : INIC
******************/
const user = (user_ini_data = initialState, action = {}) => {
  switch (action.type) {
    // Set user authorized token
    case types.SET_TOKEN:
      return Object.assign({}, user_ini_data, {
        token: action.token,
      });
    // Set user logout
    case types.SET_LOGOUT:
      return Object.assign({}, user_ini_data, {
        isLogout: action.payload,
      });
    // Remove user authorized token
    case types.REMOVE_TOKEN:
      return Object.assign({}, user_ini_data, {
        token: false,
      });
    // Set login user information
    case types.SET_USER_INFO:
      return Object.assign({}, user_ini_data, {
        userInfo: action.data ? { ...user_ini_data.data, ...action.data } : "",
      });

    case types.SET_DOCUMENTS:
      return Object.assign({}, user_ini_data, {
        userInfo: { ...user_ini_data.data, ...action.data },
      });

    case types.SET_TRIPS:
      return Object.assign({}, user_ini_data, {
        trips: action.payload,
      });
    default:
      return user_ini_data;
  }
};

export default user;
